export const libsMap: { [key: string]: any } = {
  // echarts: `${process.env.STATIC_RES_DOMAIN}/libs/echarts/5.1.2/echarts-flow.min.js`,
};
